// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../components/Table";
// Engine
import { axiosAPI } from "../../../engine/config/axios";

const VacationBalanceHistoryTable:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  const gridParams = {
    grids: [{ name: 'historyBalance', hashCache }],
  }

  return <Table
    api={axiosAPI.vacation.balanceHistory.table}
    apiParams={apiParams}
    gridName="historyBalance"
    gridParams={gridParams}
    sortingMode="multiple"
  />;
}

function VacationBalanceHistoryTablePortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<VacationBalanceHistoryTable hashCache={Root?.dataset.hashCache}  />, Root) : null;
}

export default VacationBalanceHistoryTablePortal;
